<template>

  <v-footer color="primary" class="onprimary--text" app style="font-family:'Open Sans';">

    <span class="wgu-footer-left" v-html="footerDatenschutz" @click="showDatenschutz"></span>
    <v-spacer></v-spacer>
    <span class="wgu-footer-left" v-html="footerImpressum" @click="showImpressum"></span>
    <v-spacer></v-spacer>
    <span class="wgu-footer-left" v-html="footerRechtlicheHinweise" @click="showRechtlicheHinweise"></span>
    <v-spacer></v-spacer>
    <span class="wgu-footer-left" v-html="footerBarrierefreiheit" @click="showBarrierefreiheit"></span>
    <v-spacer style="flex-grow: 50 !important;"></v-spacer>
    <div class="wgu-footer-right">
      <span v-if="showCopyrightYear" >&copy; {{ new Date().getFullYear() }}</span>&nbsp;
      <span v-html="footerTextRight"></span>
    </div>
  </v-footer>

</template>

<script>

import { WguEventBus } from '../../src/WguEventBus'

export default {
  name: 'wgu-app-footer',
  props: {
    footerTextLeft: { type: String, required: true },
    footerTextRight: { type: String, required: true },
    footerDatenschutz: { type: String, required: true },
    footerImpressum: { type: String, required: true },
    footerRechtlicheHinweise: { type: String, required: true },
    footerBarrierefreiheit: { type: String, required: true },
    showCopyrightYear: { type: Boolean, required: false, default: true }
  },
  methods: {
    hideAllOther () {
      WguEventBus.$emit('wgu-impressum-visibility-change', false);
      WguEventBus.$emit('wgu-datenschutz-visibility-change', false);
      WguEventBus.$emit('wgu-rechtlichehinweise-visibility-change', false);
      WguEventBus.$emit('wgu-barrierefreiheit-visibility-change', false);
    },
    showImpressum () {
      this.hideAllOther();
      WguEventBus.$emit('wgu-impressum-visibility-change', true);
    },
    showDatenschutz () {
      this.hideAllOther();
      WguEventBus.$emit('wgu-datenschutz-visibility-change', true);
    },
    showRechtlicheHinweise () {
      this.hideAllOther();
      WguEventBus.$emit('wgu-rechtlichehinweise-visibility-change', true);
    },
    showBarrierefreiheit () {
      this.hideAllOther();
      WguEventBus.$emit('wgu-barrierefreiheit-visibility-change', true);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

  /* vuetify breakpoint xs */
  @media only screen and (max-width: 800px) {
    .v-footer {
      font-size: 14px;
    }
  }  @media only screen and (max-width: 600px) {
    .v-footer {
      font-size: 12px;
    }
  }
  /* avoid special color for links in footer */
  .v-footer a {
    color: inherit !important;
  }

  .v-footer a:hover {
    font-weight: bold;
    letter-spacing: -0.2px;
  }

</style>
